var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rest-date"},[[_vm._t("default",null,{"timestamp":_vm.isUnixDate ? _vm.timestamp : (new Date(_vm.timestamp)).getTime()})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }